import * as yup from "yup";

/**
 * Yup validation schema for changing a user's password.
 *
 * Validates the following fields:
 * - password: Required string with a minimum of 6 characters.
 * - password_confirmation: Required string that must match the entered password.
 *
 * Error messages are localized in German.
 */
const changePasswordValidation = yup.object().shape({
  password: yup
    .string()
    .required("Passwort wird benötigt")
    .min(6, "Das Passwort muss mindestens aus 6 Zeichen bestehen"),
  password_confirmation: yup
    .string()
    .required("Eine Passwortbestätigung ist erforderlich")
    .test(
      "password-match",
      "Die Passwörter müssen übereinstimmen",
      function (value) {
        const { password } = this.parent;
        return password === value || value === null;
      }
    ),
});

export default changePasswordValidation;
